const CHANGE_SYSTEM_LOCALE = 'intl/CHANGE_SYSTEM_LOCALE';

export default {
  CHANGE_SYSTEM_LOCALE,
};
